export function titleTag(title: string) {
  return `${title} - ${process.env.NEXT_PUBLIC_TITLE ?? 'ATS'}`;
}

export function setTitleTag(
  title?: string | undefined,
  slug?: string | number
) {
  if (title) {
    document.title = titleTag(title);
    return;
  }
  slug = String(slug ?? '');
  if (slug && slug.length > 1) {
    document.title = titleTag(slug[0].toLocaleUpperCase() + slug.slice(1));
    return;
  }
  if (slug) {
    document.title = titleTag(slug.toLocaleUpperCase());
    return;
  }
  document.title = process.env.NEXT_PUBLIC_TITLE
    ? process.env.NEXT_PUBLIC_TITLE
    : 'ATS';
}

export async function staticTitleTag(
  title: string,
  locale?: string,
  returnObject = true as boolean
) {
  if (!locale) {
    const finalTitle = `${title} - ${process.env.NEXT_PUBLIC_TITLE ?? 'ATS'}`;
    if (returnObject) {
      return {
        title: finalTitle,
      };
    }
    return finalTitle;
  }
  const messages = await import(`../../messages/${locale}.json`);
  let message = messages as any;
  const path = title.split('.');
  path.forEach((chunk) => {
    message = message[chunk];
  });
  const finalTitle = `${String(message)} - ${process.env.NEXT_PUBLIC_TITLE ?? 'ATS'}`;
  if (returnObject) {
    return {
      title: finalTitle,
    };
  }
  return finalTitle;
}
